import { FC } from "react";
import Button from "@lhd/components/Button";
import useModalConfirm, { Props, ReceivedProps } from "./hook";
import { ModalWrapper } from "./styled";
import { DISPLAY_SIZES } from "@lhd/types";

const ModalConfirmLayout: FC<Props & { text_scale?: any }> = ({
  isSubmitting = false,
  isOpen,
  content,
  onCancel,
  onOk,
  width,
  okText,
  cancelText,
  className,
  text_scale,
  zIndex,
  cancelButtonStyle,
  cancelButtonClassName,
  okButtonClassName,
  wrapClassName,
}) => {
  const modalWidth = width ?? (text_scale === DISPLAY_SIZES.LARGE ? 450 : 400);

  return (
    <ModalWrapper
      width={modalWidth}
      zIndex={zIndex}
      open={isOpen}
      text_scale={text_scale || DISPLAY_SIZES.SMALL}
      wrapClassName={wrapClassName}
      footer={
        <>
          <Button
            label={okText || "はい"}
            loading={isSubmitting}
            onClick={onOk}
            type="submit-btn"
            className={okButtonClassName}
          />
          {onCancel && (
            <Button
              label={cancelText || "いいえ"}
              onClick={onCancel}
              disabled={isSubmitting}
              type="cancel-btn"
              className={cancelButtonClassName}
              style={cancelButtonStyle}
            />
          )}
        </>
      }
    >
      <p className={className}>{content}</p>
    </ModalWrapper>
  );
};

const ModalConfirm: FC<ReceivedProps & { text_scale?: any }> = (props) => (
  <ModalConfirmLayout
    {...useModalConfirm(props)}
    text_scale={props.text_scale}
  />
);

export default ModalConfirm;
